<style lang="less" scoped>
h2 {
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
  margin-bottom: 15px;
  border-bottom: 1px dashed #858585;
}
#datas {
  background: #fff;
  // padding: 0 15px 25px;
  box-sizing: border-box;
}
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  empty-cells: show;
  vertical-align: top;
  background: #fff;
  margin-bottom: 25px;
  overflow-x: auto;
  overflow-y: hidden;
}

table thead {
  background: #f1f1f1;
}

table th {
  padding: 5px;
  font-size: 12px;
  border: 1px solid #e5e5e5;
  word-break: break-word;
  word-wrap: break-word;
}

td {
  text-align: center;
  border-right: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  padding: 8px;
  font-size: 12px;
}
.nodata {
  text-align: center;
  padding: 25px 0;
  width: 100%;
  font-size: 14px;
  img {
    width: 11.91667rem;
  }
}
td:first-child {
  border-left: 1px solid #e5e5e5;
}
</style>
<template>
  <section>
    <div id="datas">
      <h2>解析来源国</h2>
      <table align="center" class="quoteTop" v-if="country.length > 0">
        <thead>
          <th style="text-align: center">排名</th>
          <th style="text-align: center">来源国</th>
          <th style="text-align: center">解析量</th>
        </thead>
        <tbody id="lists">
          <tr v-for="(item, index) in country" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.country }}</td>
            <td>{{ item.total }}</td>
          </tr>
        </tbody>
      </table>
      <div v-else class="nodata">
        <img src="@/assets/images/nodata.png" />
        <p>暂无来源国数据</p>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      prefix: "",
      country: [],
      loading: true,
      endTime: "",
    };
  },
  mounted() {
    this.prefix = this.$getUrlParam("prefix");
    if (this.$getUrlParam("endTime")) {
      this.endTime = this.$getUrlParam("endTime");
    }
    this.getData();
  },
  methods: {
    getData() {
      this.axios
        .get(
          "pid-cstr-service/log.resolveCountry.ByPrefix?prefix=" +
            this.prefix +
            "&endTime=" +
            this.endTime
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.loading = false;
            this.country = res.data.data.content;
          } else if (res.data.code == 500) {
            this.loading = false;
          }
        });
    },
  },
};
</script>